const diagramsToken = {
	node: "diagrams",
	getAttrs: (tok) => tok?.attrs,
};

export default diagramsToken;
